import React from 'react'
import Link from '../utils/link'
import Fade from 'react-reveal/Fade'

const ThankyouBlocks = (props) => {

  const { title, content, leftButtonText, rightButtonText, image } = props

  return (
    <section className='thankyou-blocks' data-color="#FFFFFF">
      <Fade bottom distance='25px'>
        <div className='thankyou-blocks__inner' data-color="#F1F1F2">
          {title && (<h2 className='title'>{title}</h2>)}
          {content && (<p className='thankyou-blocks__content'>{content}</p>)}
          <div className='thankyou-blocks__btngroup'>
            {leftButtonText?.title && (
              <Link
                to={leftButtonText.url}
                className='thankyou-blocks__lbutton'
              >{leftButtonText.title}</Link>
            )}
            {rightButtonText?.title && (
              <Link
                to={rightButtonText.url}
                className='thankyou-blocks__rbutton'
              >{rightButtonText.title}</Link>
            )}
          </div>
          {image?.localFile?.publicURL && (
            <div className='thankyou-blocks__image'>
              <img src={image.localFile.publicURL} alt={image.alt} />
            </div>
          )}
        </div>
      </Fade>
    </section>
  )
}

export default ThankyouBlocks